const initialState = {
    apiLoggers: [],
    ddConfigurations: [],
    groupDDConfigurations: [],
    defaultDictionaries: [],
    ddConfig: {
        fieldName: '',
        fieldType: '',
        referenceId: '',
        active: '',
        deletedIndex: '',
    },
    fieldNames: [],
    gridDDConfigurations: {
        fielddata: [
            {
                header: 'Ref Id',
                inputfield: false,
                length: 10,
                name: 'ref_id',
                placeholder: 'e.g. REF2020121212 ',
            },
            {
                header: 'Field Name',
                inputfield: true,
                length: 10,
                name: 'field_name',
                placeholder: '',
            },
            {
                header: 'Field Type',
                inputfield: true,
                length: 10,
                name: 'field_type',
                placeholder: '',
                dropdown: true,
            },
            {
                header: 'Active',
                inputfield: false,
                length: 1,
                name: 'active',
                placeholder: 'e.g. Y/N',
            },
            {
                header: 'Created date',
                inputfield: false,
                length: 1,
                name: 'created_date',
                placeholder: 'e.g Integer',
            },
        ],
        instances: [],
    },
};

export default initialState;
